<template>
  <div>
    <b-modal
      id="calendar-modal"
      @hide="closeModal" 
      @shown="onModalShown"
      hide-footer 
      size="xl"
      >
      <template slot="modal-header">
          <h4 class="modal-title">{{ dailyTask.name ?? '' }}</h4>
          <a class="btn-close" @click="closeModal"></a>
      </template>
      <div class="row">
        <div class="col-12 col-md-6">
          <FullCalendar ref="fullCalendar" :options="calendarOptions" />
        </div>
        <div class="col-12 col-md-6">
          <ul class="list-group">
            <li v-for="schedule in dailyTask.schedules" :key="schedule.id" class="list-group-item">
              <div class="row">
                <div class="col-6 fw-bold">{{ schedule.creator }}</div>
                <div class="col-6 text-right">{{ schedule.created_at }}</div>
                <div class="col-12">{{ schedule.comment }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <b-modal id="form-modal" hide-footer hide-header @shown="onCommentModalShown">
      <form @submit.prevent="submitForm">
        <div class="form-group">
          <label for="comment">Megjegyzés</label>
          <textarea class="form-control mt-2" ref="commentField" cols="30" rows="10" v-model="newScheduleItem.comment"></textarea>
        </div>
        
        <div class="d-flex justify-content-end mt-3">
          <button type="button" class="btn btn-default" @click.prevent="cancelSchedule">Mégsem</button>
          <button type="submit" class="btn btn-primary ms-1">Mentés</button>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<style>
.fc .fc-daygrid-body{
  border-bottom:1px solid #CCCCCC;
}
</style>
  
<script>
  import FullCalendar from '@fullcalendar/vue'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import interactionPlugin from '@fullcalendar/interaction'
  import DailyTaskSchedule from '../../../apis/DailyTaskSchedule';
  import Confirmation from "../../../apis/Confirmation";
  export default {
    components: {
      FullCalendar
    },
    props: {
      dailyTask: Object
    },
    data() {
      return {
        calendarOptions: {
            plugins: [ dayGridPlugin, interactionPlugin ],
            initialView: 'dayGridMonth',
            selectable:true,
            headerToolbar: {
              left: 'prev,next',
              center: 'title',
              right: ''
            },
            events: this.$props.dailyTask.schedules,
            locale:'hu',
            selectOverlap: this.preventOverlap,
            select: this.handleDateSelect,
            eventClick: this.deleteScheduleItem,
            eventMouseEnter: this.handleMouseEnter, // Mouse enter event
            eventMouseLeave: this.handleMouseLeave, // Mouse leave event
        },
        newScheduleItem: {
          daily_task_id: null,
          start_date: '',
          end_date: '',
          comment: ''
        }
      }
    },
    watch: {
      dailyTask: {
        immediate: true, // Trigger immediately on component mount
        handler(newTask) {
          // When dailyTask changes, update newScheduleItem.daily_task_id
          if (newTask && newTask.id) {
            this.newScheduleItem.daily_task_id = newTask.id;

            // Update calendar events when a new task is selected
            
          }
        }
      }
    },
    methods: {
      openModal(){
        this.$bvModal.show('calendar-modal');
      },
      closeModal(){
        this.$bvModal.hide('calendar-modal');
      },
      onModalShown() {
        this.$refs.fullCalendar.getApi().removeAllEvents();
        this.$refs.fullCalendar.getApi().addEventSource(this.dailyTask.schedules);
        // Trigger resize on FullCalendar
        this.$refs.fullCalendar.getApi().updateSize();
        this.$refs.fullCalendar.getApi().render();
      },
      // Triggered when a date or date range is selected
      handleDateSelect(selectionInfo) {
        const start = selectionInfo.startStr; // Start date
        const end = selectionInfo.endStr;     // End date

        this.newScheduleItem.start_date = start;
        this.newScheduleItem.end_date = end;
        this.$bvModal.show('form-modal');
      },
      onCommentModalShown() {
        this.$refs.commentField.focus();
      },
      cancelSchedule() {
        console.log('canceled');
        this.$bvModal.hide('form-modal');
        this.$refs.fullCalendar.getApi().unselect(); // Unselect the selected date range
      },
      submitForm() {
        DailyTaskSchedule.add(this.newScheduleItem)
          .then((response) => {
            this.addTaskToCalendar(response.data.dailyTaskSchedule); // Add the event to the calendar            
            this.$emit('saved');
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.newScheduleItem.comment = ''; // Clear the comment field
            this.$refs.fullCalendar.getApi().unselect(); // Unselect the selected date range
          });

        // Close the form modal
        this.$bvModal.hide('form-modal');
      },

      // Use this method to add the event to the calendar
      addTaskToCalendar(scheduleItem) {
        this.$refs.fullCalendar.getApi().addEvent({
          id: scheduleItem.id,
          start: scheduleItem.start_date,
          end: scheduleItem.end_date,
        });
      },
      preventOverlap(event) {
        return !event; // If there's an event, return false to prevent overlap
      },
      deleteScheduleItem(clickInfo) {
        Confirmation.swalDelete().then((response) => {
          if(response.isConfirmed === true){
            const eventId = clickInfo.event.id;
            DailyTaskSchedule.delete(eventId)
              .then(() => {
                clickInfo.event.remove(); // Remove the event from the calendar
                this.$emit('saved');
              })
              .catch((error) => {
                console.error(error);
              });
          }
        });
      },
      handleMouseEnter(mouseEnterInfo) {
        const eventEl = mouseEnterInfo.el; // The element representing the event
        eventEl.style.backgroundColor = 'red'; // Change to your desired hover color
        eventEl.style.borderColor = 'red'; // Change border color if needed
        eventEl.style.cursor = 'pointer'; // Change border color if needed
      },

      // Reset event color on mouse leave
      handleMouseLeave(mouseLeaveInfo) {
        const eventEl = mouseLeaveInfo.el; // The element representing the event
        const originalColor = '#348FE2';
        eventEl.style.backgroundColor = originalColor; // Reset to original color
        eventEl.style.borderColor = originalColor; // Reset border color if needed
      }
    }
  };
  </script>
  